import { ICellRendererParams } from "ag-grid-community";
import {
  NeverEverAccreditationStatus,
  NeverEverEligibilityStatus,
} from "constants/greenhams";
import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import { faCheck, faWarning } from "@fortawesome/free-solid-svg-icons";
import React from "react";

export function neverEverAccreditationStatusRenderer(
  params: ICellRendererParams,
) {
  const { value } = params;

  if (value === NeverEverAccreditationStatus.ACCREDITED) {
    return <FaIcon icon={faCheck} color="success" />;
  }
  if (value === NeverEverAccreditationStatus.ELIGIBILITY_CHECK_ERROR) {
    return <FaIcon icon={faWarning} color="error" />;
  }
  return "";
}

export function neverEverEligibilityStatusRenderer(
  params: ICellRendererParams,
) {
  const { value } = params;

  if (value === NeverEverEligibilityStatus.ELIGIBLE) {
    return <FaIcon icon={faCheck} color="success" />;
  }
  if (value === NeverEverEligibilityStatus.ELIGIBILITY_CHECK_ERROR) {
    return <FaIcon icon={faWarning} color="error" />;
  }
  return "";
}
